import tw from 'twin.macro';

export const Wrapper = tw.main`
  relative min-h-screen w-full max-w-screen-md shadow-2xl mx-auto flex
`;
